import { render, staticRenderFns } from "./Dance.vue?vue&type=template&id=71f838e2"
import script from "./Dance.vue?vue&type=script&lang=js"
export * from "./Dance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports